import React, { useState, useEffect } from "react";
// import 'react-pagination-bar/dist/index.css'
// import "./ReportCss/Report1.css"
// import "react-data-export";

import "file-saver"
import XSLX from "sheetjs-style"
import FileSaver from "file-saver";

import DialogSelect from '../../Components/Global/DialogSelect'
// import { getRadioUtilityClass, stepButtonClasses } from "@mui/material";
// import { SignalCellularNullRounded } from "@mui/icons-material";
import ColumnResizer from "react-column-resizer";
import axios from 'axios';
import { Worker, Viewer } from '@react-pdf-viewer/core';
// import '@react-pdf-viewer/core/lib/styles/index.css';


const ReportTable = (props) => {


    const {cntrct, cntComp, currentKey, reportParams, colsParam, urlParam
        , reportData, setReportData, handleTab } = props
    // const [data, setDataR] = useState([]);
    const [orginalData, setDataBefFilter] = useState([]);
    const [loadingStt, setLoadingStt] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPage] = React.useState(6000); // reportParams? reportParams.NumRowsPerPage : window.innerHeight / 25);
    const [pageViewT, setPageViewType] = useState('2');
    const [count, setCount] = React.useState(10);//
    const [orderDirection, setOrderDirection] = useState("asc");
    const [freeSearch, setFreeSearch] = useState("");
    const [cols, SetCols] = useState([]);
    const [listNumPerPage, SetListNumPerPage] = useState([5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100]);
    const [selectedRow, SetSelectedRow] = useState(-1);


    const [heightScreen, setHeightScreen] = useState(window.innerHeight);

  useEffect(() => {
    setHeightScreen(window.innerHeight);
    window.addEventListener("resize", () => setHeightScreen(window.innerHeight));
    return () => window.removeEventListener("resize", () => setHeightScreen(window.innerHeight));
  }, []);

    
  useEffect(() => {
    debugger;
    loadData(reportData);
  }, [cntrct, currentKey])

  useEffect(() => {
    debugger;
    if(reportData != null && reportData.length>0 && loadingStt.length > 0)
        setLoadingStt(''); 
  }, [rowsPerPage]) 
  
  useEffect(() => {
    debugger;
    if(reportData != null && reportData.length>0 && selectedRow >= 0)
        SetSelectedRow(-1);
  }, [rowsPerPage, page, count, orderDirection])

  
  async function loadData(paramData) {

    debugger;
    var resJson = paramData;  

    if(paramData == null || paramData.length == 0)
      {

            debugger;
            setLoadingStt('Loading');   
            setReportData([]); //setDataR([]);
            setDataBefFilter([]);



            try {
              debugger;
              var lastDTime = new Date(localStorage.getItem("dt"));
              var lastHour = new Date(Date.now() - (1 * (60 * 60 * 1000)) );
              debugger;
              if(lastHour > lastDTime)
              {
                debugger;
                setLoadingStt(''); 
                window.history.replaceState(null, '', '/'); //עבר שעה מהפעולה הקודמת
                window.location.reload();
                return;
              }
              debugger;

              const api = axios.create({
                baseURL: process.env.REACT_APP_BASE_URL,
                headers: {
                  'Content-Type': 'text/json',
                },
                auth: {
                  username: process.env.REACT_APP_AUTH_USERNAME ,
                  password: process.env.REACT_APP_AUTH_PASSWORD ,
                },
              });

              try{ 
                 const url = urlParam;
              const response = await api.get(url);
              resJson = response.data;
              }  
              catch(error){ console.log('error-- ' + error);setLoadingStt('error ' + error);}
              finally{console.log("---" + reportData); setLoadingStt(''); };
              
             
              // await fetch(url)
              //     .then((response) => response.json()) 
              //     .then((res) => { resJson = res;})
                
              //     .catch((error) => { console.log('error-- ' + error); setLoadingStt('error ' + error); })
              //     .finally(() => { console.log("---" + reportData); setLoadingStt(''); });
            }
            catch
            { 
            debugger;
            //  setDataBefFilter(data);
            }

        }

   debugger;
     if(colsParam != undefined)
     {
        var colParams = colsParam;  
        
        colParams.map((col) => {
            if(col.IsSumerize)
                 col.Sumerize = 0;
            if(col.DisplayJustHasVal && resJson.some(item => item[col.Id] != "" || item[col.Id] != null)) 
            {        
                debugger;       
                resJson = resJson.filter(x => x.Id !== col.Id)
                colParams = colParams.filter(x => x.Id !== col.Id)
            }
                
          });


        //delete resJson.pdf2;

        resJson.map((item) => {
            colParams.map((col) => {
                if(col.IsSumerize)
                        col.Sumerize += Number(item[col.Id].replace(/,/g, ''))
                });
        })

        
        setReportData(resJson); //setDataR(res);
        setDataBefFilter(resJson);
        setCount(resJson.length);

        

        console.log(colParams);
        colParams.map((item) => {
        if(item.AddFilter)
                item.AllVals = FillCombo(resJson, item.Id);
        });
        console.log('after fill');
        console.log(colParams);

        SetCols(colParams);

        localStorage.setItem("dt", new Date());
    }
  }

  
  const handleSort = (uid) => {

    debugger;
    var sortedData = sortArray(reportData, orderDirection, uid);//data
    setReportData(sortedData);//setDataR(sortedData);
    setOrderDirection(orderDirection === "asc" ? "desc" : "asc");
  };
  
  const sortArray = (arr, orderBy, uid) => {
    
    debugger;
    switch (orderBy) {
      case "asc":
      default:
        if(uid.includes("qty") || uid.includes("total")|| uid.includes("Qty") || uid.includes("app"))
        {
          return arr.sort((a, b) =>
          ToNum(a[uid]) > ToNum(b[uid]) ? 1 
                    :  ToNum(b[uid]) > ToNum(a[uid]) ? -1 : 0 );
        }
        else if(uid.toUpperCase().includes("DATE"))
       {
        return arr.sort((a, b) =>
        Date(a[uid]) > Date(b[uid]) ? 1 
        :  Date(b[uid]) > Date(a[uid]) ? -1 : 0 );
       }
       else
       {
          return arr.sort((a, b) =>
          a[uid] > b[uid] ? 1 :  b[uid] > a[uid] ? -1 : 0 );
       }
      case "desc":
        if(uid.includes("qty") || uid.includes("total") || uid.includes("Qty") || uid.includes("app"))
        {
        return arr.sort((a, b) =>
        ToNum(a[uid]) < ToNum(b[uid]) ? 1 
                  :  ToNum(b[uid]) < ToNum(a[uid]) ? -1 : 0
        );
        }
        else if(uid.toUpperCase().includes("DATE"))
        {
         return arr.sort((a, b) =>
         Date(a[uid]) < Date(b[uid]) ? 1 
         :  Date(b[uid]) < Date(a[uid]) ? -1 : 0 );
        }
        else
        {
          return arr.sort((a, b) =>
          a[uid] < b[uid] ? 1 :  b[uid] < a[uid] ? -1 : 0 );
        }
    }
  };

  const ToNum= (val) =>
  {
   // return Number(val.replace(/,/g, '').replace('@', '').replace('*', ''));
    return Number(val.replace(/\D/g, ''));
  }

  
  const handleSearch = (e) => {

    debugger;

    setPage(0);
    var valueSrch = e.target.value;
     setFreeSearch(valueSrch);

    handleSearchInCol(valueSrch, cols);
  };

  const handleSearchInCol = (valueSrch, colsData) => {
 
    debugger;
    var afterFilterData = [];
      
    if (orginalData.length === 0)
      setDataBefFilter(reportData); //data

    afterFilterData = orginalData;       
    if(colsData != "")
    {
        colsData.map(col => {
            if(col.AddFilter && col.SelectedVals.length > 0)
                afterFilterData = afterFilterData.filter((filter) => (col.SelectedVals.find(val => val === filter[col.Id]) 
                    || (col.SelectedVals.includes("") && filter[col.Id].length == 0 )));  
        });    
    }
 
    debugger;
    if(valueSrch.length > 0 )
    { 
       afterFilterData=  afterFilterData.filter(function(obj) {
        return Object.keys(obj)
                     .some(function(k) { 
                               return obj[k] != null && obj[k].indexOf(valueSrch) !== -1; 
                           });
    });
    }

    setReportData(afterFilterData);//setDataR(afterFilterData)

    cols.map((col) => {
        if(col.IsSumerize)
             col.Sumerize = 0;
      });

    afterFilterData.map((item) => {
        cols.map((col) => {
            if(col.IsSumerize)
                 col.Sumerize += Number(item[col.Id].replace(/,/g, ''))
          });
      })

    setCount(afterFilterData.length);
    setPage(0);

  };

  const onClearFiltersClick =() => {
    debugger;
    setReportData([]);
    loadData([]);

    
    //איפוס פילטרים
    cols.map((col) => {
    if(col.AddFilter)
            col.SelectedVals = [];
    });
    setFreeSearch("");    
    SetSelectedRow(-1);
    // handleSearchInCol( "", "");
  };

  // const [pathPdf, setPathPdf] = useState("doc.pdf");
   
  async function GetUrl (rowData, colId) 
  {
    console.log(rowData["docNum"]);
    console.log(cntComp);
    console.log(cntrct);
debugger;

    //const fetchPdf = async () => {
      try {
        const url = 'https://proxy.tuboul.co.il/GetPDF?token='+ cntrct +'&comp='+ cntComp +'&tbl=OQUT&docNum='+ rowData["docNum"] +'';

        debugger;
        const api = axios.create({
          baseURL: process.env.REACT_APP_BASE_URL,
          headers: {
            'Content-Type': 'text/json',
          },
          auth: {
            username: process.env.REACT_APP_AUTH_USERNAME ,
            password: process.env.REACT_APP_AUTH_PASSWORD ,
          },
        });

        debugger;
        // המצב של הבקשה לקובץ PDF עם אימות
        const response = await api.get(url, {
          responseType: 'blob', // סוג המידע שמצפים לקבל - קובץ בינארי
        });
        debugger;
        // כאשר הבקשה בוצעה בהצלחה, מקבלים את כתובת ה-URL של ה-PDF
        const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
        const pdfObjectURL = URL.createObjectURL(pdfBlob);
        window.open(pdfObjectURL);
        // setPathPdf(pdfObjectURL);
        debugger;
      } catch (error) {
        debugger;
        console.error('שגיאה בקבלת קובץ PDF:', error);
      }
    //}

//setPathPdf( "samba2.pdf" );  
   
   //   var p= "C:\\Users\\todan\\Downloads\\PDF%20TEMPLATE.pdf";
     // const url = "http://82.80.69.104:5679/API/getdoc?path="+path;
   

     // setPathPdf( url ); 
debugger;
  
      
  };

  function FillCombo(res, id) {
    
   
    if(res == [] || res == null || res == undefined )
     return [];

    var tempMap = [];
    var mapCol = res.map(item => {
      if (!tempMap.includes(item[id])) {
        tempMap.push(item[id]);
        return { value: item[id] };
      }
    }); 
    
    if(tempMap.length > 0 )
    {
         

         tempMap = tempMap.sort();

        if(id == "app" || id == "bld")
            tempMap = tempMap.sort((a, b) =>
                    ToNum(a) > ToNum(b) ? 1 
                    :  ToNum(b) > ToNum(a) ? -1 : 0 );
        // else 
        //     tempMap = tempMap.sort((a, b) =>
        //         a > b ? 1 :  b > a ? -1 : 0 );

    }
      
            
    // tempMap.unshift("הכל");
    return tempMap;
  }

  
  
  const handleFirstPageButtonClick = (event) => {
    debugger;
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    debugger;
    if(page > 0)
        onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
     debugger;
    if(page+1 < (Math.ceil(count / rowsPerPage)))
      onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    debugger;
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  function onPageChange(event, newPage) {
    debugger;
    setPage(newPage);
  }

  const setRowsPerPage= (num) => {
  
    debugger;
    setRowsPage(num);
    reportParams.NumRowsPerPage = num;
  }

  const onSelectPage = (event) => {  
     
    setLoadingStt('Loading'); 
  
    if(event.target.value == "--")
      setRowsPerPage(getNumRowsInPage(''));
    else
      setRowsPerPage(event.target.value);
    setPage(0);
   
  }

  const onSelectViewPage = (event) => {

    debugger;
    var selected = event.target.value;
    setPageViewType(selected);
    var rowPerPage = getNumRowsInPage(selected);    
    setRowsPerPage(rowPerPage);
    setPage(0);
  }

  const getNumRowsInPage = (pageViewType)  =>
  {
    debugger;
    var res = 0;
    if(pageViewType == "2")
      res = window.innerHeight / 24;
    else
    var   res = window.innerHeight / 25;
    return res;
  }


//   const ITEM_HEIGHT = 48;
//   const ITEM_PADDING_TOP = 20;
//   const MenuProps = {
//     PaperProps: {
//       style: {
//         maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//         width: 280,
//       },
//     },
//   };


  
  const handleChange = (indx, valToSet) => {

    debugger;

    let colData = cols;
    cols[indx].SelectedVals = valToSet;
    SetCols(colData);
 
    handleSearchInCol(freeSearch, colData);
 
  };

  const OnDtlsClick =(col, val, indx) => {
    if(col.ConstVal == "...")
         handleTab("rpt3");
  };
  
  const OnClick =(col, indx) => {
    
    if(selectedRow != indx && col != '#')
         SetSelectedRow(-1);
    else
         SetSelectedRow(indx);

  };


  
  const ExpoerExcel = async()  => {

    try
    {
      debugger;
 
    //   var dataToExport= '[';
    //   reportData.map((row, i) =>  
    //     {   
    //     dataToExport = dataToExport +"{";   
    //     cols.map((col, index) => {   
    //         dataToExport += col.Id +":"+ row[col.Id] +",";
    //                             } );
    //     dataToExport += "}, ";  
    //      } 
    //       );

    //   dataToExport += "] ";  


    var jsonToExcel = reportData;
    // cols.map((col) => {
    //     // if(col.IsSumerize)
    //     //      col.Sumerize = 0;
    //     if(col.DisplayJustHasVal) 
    //     {            
    //         jsonToExcel = jsonToExcel.filter(x => x.Id !== col.Id)
    //       //  colParams = colParams.filter(x => x.Id !== col.Id)
    //     }
            
    //   });
   // var jsonToExcel = reportData.map((col, index) => {return col.Id == "bld" ? delete col.Id : ''}); ;
   // var jsonToExcel = reportData.filter(x => x.id !== "bld");
    //var jsonToExcel = reportData.filter(x => x.Id == cols.map((col) => {return col.Id == x.Id ? col.Id : ''}));
    // console.log('111'); 
    // console.log(reportData); 
    //delete jsonToExcel[0]["bld"];

    
   var colsName = cols.map((col, index) => {return !col.LinkImg && !col.ConstVal ?  col.Name : ''});
   var colsId = cols.map((col, index) => {return !col.LinkImg && !col.ConstVal ?  col.Id : ''});

//    var colsIdJson = jsonToExcel.map((itm, index, key) => {return index});
//    var colsIdJson2 = jsonToExcel.map((itm, index, key) => {return key});
//   var colsIdJson3 = jsonToExcel.map((itm) => {return Object.keys(itm).map(key => {
//     return key;})});
//     var colsIdJson4 = jsonToExcel.map((itm) => {return Object.keys(key => {
//         return key;})});
    var colsIdJson5 = Object.keys(jsonToExcel[0]).map(key => {
            return key;});

   // jsonToExcel.map(item => delete item["bld"]);
    jsonToExcel.map(item =>
         {for (let i = 0; i < colsIdJson5.length; i++) {      
        if(!colsId.includes(colsIdJson5[i]) )
            delete item[colsIdJson5[i]];
         else if(cols[colsId.indexOf(colsIdJson5[i])].IsSumerize)
            item[colsIdJson5[i]] = Number(item[colsIdJson5[i]].replace(',', '')); // ToNum(item[colsIdJson5[i]]);

    }} );

    
    //delete jsonToExcel[0].slice("bld");

     //var jsonToExcel = reportData;
   //  jsonToExcel = cols.map((col) => {jsonToExcel.filter(x => x.Id !== col.Id)});
     console.log(reportData); 
     console.log(jsonToExcel); 

      const fileType = "application/octet-stream";

      const ws = XSLX.utils.json_to_sheet(jsonToExcel, {header:colsId});////data// dataExcelArr orginalData
      XSLX.utils.sheet_add_aoa(ws, [colsName], { origin: "A1" });

     // var cell = ws['A1'];
      //delete ws['A1'];
        // ws['A1'].v = "ABC";
  // ws['A1'].type = typeof(Intl);;

      const wb = {Sheets: {'data':ws}, SheetNames:['data'] }; 
       // var nextCell = wb.Sheets[0][XSLX.utils.encode_cell({r: 0, c: 1})];
     // nextCell.type = typeof(Intl);
      //wb.Sheets['data'][1] = "מממ";
      const wbout = XSLX.write(wb, {type:"array", bookType:"xlsx"});
      const dataExcel = new Blob([wbout], {type: fileType });//excelBuffer
      const fileName =  "report" + new Date().toLocaleString() + ".xlsx";
      console.log(fileName); 
      FileSaver.saveAs(dataExcel, fileName);
    }
    catch(error)
    {
      debugger;
      console.log(error);
    }
  };


  // const TableContainer = (props) => {
  //   const containerStyles = {
  //     overflow: 'auto',
  //     height: `${heightScreen-150}px`
  //   };
  //   return (
  //     <div style={containerStyles}>
  //       {props.children}
  //     </div>
  //   );
  // }

  return (
    <div className="Filter1"  >
      {loadingStt.length > 0 && <div className="loader-container"> <div className="spinner"></div> </div>}

      <tr className="trPagination" >

        <div className="pagination">
        {/* <a> <button className="cls" onClick={() => ExpoerExcel()} style={{backgroundImage:"url('./images/icons-excel-48.png')",backgroundSize:"cover", width:"20px", height:"20px"}}> </button></a> */}
        <a className="cls" onClick={() => ExpoerExcel()} style={{direction:"rtl", filter: "grayscale(100%)", textDecoration: "underline"}}>יצא לאקסל ▼</a>
          <a>
            <select onChange={onSelectPage} style={{border: "None", textDecoration: "underline", direction:"rtl", width: 45}}>
              <option value="--">הצג שורות</option>
              {listNumPerPage.map(item => {return ( <option value={item}>{item}</option>);})}
              {reportData != null && reportData.count > 6000 ? <option value={rowsPerPage} selected>6000</option> : ''}
              <option value='99999'>הכל</option>
            </select></a>      
          <a>
            <select onChange={onSelectViewPage} onfocus="this.selectedIndex = -1;"style={{border: "None", textDecoration: "underline", direction:"rtl", width: 55}}>
              <option value="--" disabled selected>תצוגה</option>
              <option value="1">גלישת טקסט</option>
              <option value="2">מצומצם</option>
            </select></a>

          <a className="page-link" href="#" onClick={handleFirstPageButtonClick} disabled={page === 0}>&laquo;</a>
          <a className="page-link" href="#" onClick={handleBackButtonClick} disabled={page === 0}>&lt;</a>
          <a className="page-link" href="#" onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>&gt;</a>
          <a className="page-link" href="#" onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>&raquo;</a>


          {reportData != null ? <a>מספר שורות {new Intl.NumberFormat().format(reportData.length)}</a> : ''}
          {/* data */}
          <a>עמוד {page+1} מתוך {Math.ceil(count / Math.ceil(rowsPerPage))} </a>
        
          <a>  
          <button onClick={onClearFiltersClick}  style={{marginLeft:550}}>נקה בחירה</button>
          <input className="txtFreeSrch" placeholder="חיפוש חופשי" value={freeSearch} onChange={(e) => handleSearch(e)} ></input>
          </a>

        </div>
      </tr>
      <div style={{overflow: 'auto', height: `${heightScreen-150}px`}}>
      <table id="tableRpt" className="Report" >
        <thead>
          <tr>
          <th style={{width:10}}>#</th>
          {cols.map((col, index) => {
              return (<th onDoubleClick={() => handleSort(col.Id)} style={{width: col.Spcwidth > 0 ? col.Spcwidth : 100}}> {col.Name}                   
             
                 {col.AddFilter ? <DialogSelect uid ={col.Id} index = {index} arrAll = {col.AllVals} arrSelected = {col.SelectedVals} positionL = "90%" 
                             setAfterSelect={handleChange}  listVals = {FillCombo(reportData, col.Id)} ></DialogSelect> : '' }
                             {/* data */}
                {col.IsSumerize ? <div className="total-reports" style={{ color: cntComp == "CM" ? "purple" : "Teal" }}
                            //  onMouseDown= {getResizeHandler()}
                            //   ontouchstart= {col.getResizeHandler()}
                               >
                                {new Intl.NumberFormat().format(col.Sumerize.toFixed(0))}                       
                                
                      </div> : ''}
       
                  </th>);
                })}         
          </tr>
        </thead>
        <tbody>
            {/* data */}
         
          {reportData != null ? (rowsPerPage > 0
            ? reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : reportData
          ).map((row, i) => (
              
             <tr style={{ whiteSpace: pageViewT != '2' ? "pre-wrap" : "nowrap"}}>

                <td style={{color: 'gray'}} 
                    onClick={() => OnClick('#', i)} >{i+ Math.ceil(page * rowsPerPage)+1}</td>
                     
                     {/* <ColumnResizer className="columnResizer"  style={{color: 'gray'}}/> */}

                {cols.map((col, index) => { 
                    return (
                    <td title={(col.Title) ? row[col.Title]: row[col.Id]} 
                        onDoubleClick={() => OnDtlsClick(col, row[col.Id], i)} 
                        onClick={() => OnClick(col.Id, i)} 
                        style={{textAlign: "flex-start", direction:"rtl", backgroundColor: selectedRow == i ? cntComp == "CM" ? "mediumpurple" : "Teal": '' }}
                        >

                            {col.LinkImg && row[col.Id] ?
                             <a onClick={() => GetUrl(row, col.Id)} /*href={pathPdf != "doc.pdf" && pathPdf != "" && pathPdf}*/  without rel="noopener noreferrer" target="_blank">
                                <img  style={{ height:12, cursor: 'pointer'}} src={"/images/icons8-pdf-24.png" }></img>
                             </a>
                            : col.ConstVal ? col.ConstVal  
                            : row[col.Id]}</td> );
                })}     
            </tr>
          )) : ''}

      
        </tbody>
        <tfoot>
        </tfoot>
      </table>

      {/* {pathPdf != "doc.pdf" && pathPdf != "" && <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.12.313/build/pdf.worker.min.js`}>
        <Viewer fileUrl={pathPdf} />
      </Worker>} */}

      </div> {/* //TableContainer */}
      
    </div>

  );



};  
  //

export default ReportTable;